/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";

export const protobufPackage = "pkt";

/** status is a uint16 value */
export enum Status {
  /** Success - client defined */
  Success = 0,
  /** NoDestination - client error 100-200 */
  NoDestination = 100,
  InvalidPacketBody = 101,
  InvalidCommand = 103,
  Unauthorized = 105,
  /** SystemException - server error 300-400 */
  SystemException = 300,
  NotImplemented = 301,
  /** SessionNotFound - specific error */
  SessionNotFound = 404,
  UNRECOGNIZED = -1,
}

export function statusFromJSON(object: any): Status {
  switch (object) {
    case 0:
    case "Success":
      return Status.Success;
    case 100:
    case "NoDestination":
      return Status.NoDestination;
    case 101:
    case "InvalidPacketBody":
      return Status.InvalidPacketBody;
    case 103:
    case "InvalidCommand":
      return Status.InvalidCommand;
    case 105:
    case "Unauthorized":
      return Status.Unauthorized;
    case 300:
    case "SystemException":
      return Status.SystemException;
    case 301:
    case "NotImplemented":
      return Status.NotImplemented;
    case 404:
    case "SessionNotFound":
      return Status.SessionNotFound;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Status.UNRECOGNIZED;
  }
}

export function statusToJSON(object: Status): string {
  switch (object) {
    case Status.Success:
      return "Success";
    case Status.NoDestination:
      return "NoDestination";
    case Status.InvalidPacketBody:
      return "InvalidPacketBody";
    case Status.InvalidCommand:
      return "InvalidCommand";
    case Status.Unauthorized:
      return "Unauthorized";
    case Status.SystemException:
      return "SystemException";
    case Status.NotImplemented:
      return "NotImplemented";
    case Status.SessionNotFound:
      return "SessionNotFound";
    case Status.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum MetaType {
  int = 0,
  string = 1,
  float = 2,
  UNRECOGNIZED = -1,
}

export function metaTypeFromJSON(object: any): MetaType {
  switch (object) {
    case 0:
    case "int":
      return MetaType.int;
    case 1:
    case "string":
      return MetaType.string;
    case 2:
    case "float":
      return MetaType.float;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MetaType.UNRECOGNIZED;
  }
}

export function metaTypeToJSON(object: MetaType): string {
  switch (object) {
    case MetaType.int:
      return "int";
    case MetaType.string:
      return "string";
    case MetaType.float:
      return "float";
    case MetaType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ContentType {
  Protobuf = 0,
  Json = 1,
  UNRECOGNIZED = -1,
}

export function contentTypeFromJSON(object: any): ContentType {
  switch (object) {
    case 0:
    case "Protobuf":
      return ContentType.Protobuf;
    case 1:
    case "Json":
      return ContentType.Json;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ContentType.UNRECOGNIZED;
  }
}

export function contentTypeToJSON(object: ContentType): string {
  switch (object) {
    case ContentType.Protobuf:
      return "Protobuf";
    case ContentType.Json:
      return "Json";
    case ContentType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum Flag {
  Request = 0,
  Response = 1,
  Push = 2,
  UNRECOGNIZED = -1,
}

export function flagFromJSON(object: any): Flag {
  switch (object) {
    case 0:
    case "Request":
      return Flag.Request;
    case 1:
    case "Response":
      return Flag.Response;
    case 2:
    case "Push":
      return Flag.Push;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Flag.UNRECOGNIZED;
  }
}

export function flagToJSON(object: Flag): string {
  switch (object) {
    case Flag.Request:
      return "Request";
    case Flag.Response:
      return "Response";
    case Flag.Push:
      return "Push";
    case Flag.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface Meta {
  key: string;
  value: string;
  type: MetaType;
}

export interface Header {
  command: string;
  /** sender channel id */
  channelId: string;
  sequence: number;
  flag: Flag;
  status: Status;
  /** destination is defined as a account,group or room */
  dest: string;
  meta: Meta[];
}

export interface InnerHandshakeReq {
  ServiceId: string;
}

export interface InnerHandshakeResponse {
  Code: number;
  Error: string;
}

function createBaseMeta(): Meta {
  return { key: "", value: "", type: 0 };
}

export const Meta = {
  encode(message: Meta, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    if (message.type !== 0) {
      writer.uint32(24).int32(message.type);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Meta {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMeta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.key = reader.string();
          break;
        case 2:
          message.value = reader.string();
          break;
        case 3:
          message.type = reader.int32() as any;
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): Meta {
    return {
      key: isSet(object.key) ? String(object.key) : "",
      value: isSet(object.value) ? String(object.value) : "",
      type: isSet(object.type) ? metaTypeFromJSON(object.type) : 0,
    };
  },

  toJSON(message: Meta): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = message.key);
    message.value !== undefined && (obj.value = message.value);
    message.type !== undefined && (obj.type = metaTypeToJSON(message.type));
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<Meta>, I>>(object: I): Meta {
    const message = createBaseMeta();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    message.type = object.type ?? 0;
    return message;
  },
};

function createBaseHeader(): Header {
  return {
    command: "",
    channelId: "",
    sequence: 0,
    flag: 0,
    status: 0,
    dest: "",
    meta: [],
  };
}

export const Header = {
  encode(
    message: Header,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.command !== "") {
      writer.uint32(10).string(message.command);
    }
    if (message.channelId !== "") {
      writer.uint32(18).string(message.channelId);
    }
    if (message.sequence !== 0) {
      writer.uint32(24).uint32(message.sequence);
    }
    if (message.flag !== 0) {
      writer.uint32(32).int32(message.flag);
    }
    if (message.status !== 0) {
      writer.uint32(40).int32(message.status);
    }
    if (message.dest !== "") {
      writer.uint32(50).string(message.dest);
    }
    for (const v of message.meta) {
      Meta.encode(v!, writer.uint32(58).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Header {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHeader();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.command = reader.string();
          break;
        case 2:
          message.channelId = reader.string();
          break;
        case 3:
          message.sequence = reader.uint32();
          break;
        case 4:
          message.flag = reader.int32() as any;
          break;
        case 5:
          message.status = reader.int32() as any;
          break;
        case 6:
          message.dest = reader.string();
          break;
        case 7:
          message.meta.push(Meta.decode(reader, reader.uint32()));
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): Header {
    return {
      command: isSet(object.command) ? String(object.command) : "",
      channelId: isSet(object.channelId) ? String(object.channelId) : "",
      sequence: isSet(object.sequence) ? Number(object.sequence) : 0,
      flag: isSet(object.flag) ? flagFromJSON(object.flag) : 0,
      status: isSet(object.status) ? statusFromJSON(object.status) : 0,
      dest: isSet(object.dest) ? String(object.dest) : "",
      meta: Array.isArray(object?.meta)
        ? object.meta.map((e: any) => Meta.fromJSON(e))
        : [],
    };
  },

  toJSON(message: Header): unknown {
    const obj: any = {};
    message.command !== undefined && (obj.command = message.command);
    message.channelId !== undefined && (obj.channelId = message.channelId);
    message.sequence !== undefined &&
      (obj.sequence = Math.round(message.sequence));
    message.flag !== undefined && (obj.flag = flagToJSON(message.flag));
    message.status !== undefined && (obj.status = statusToJSON(message.status));
    message.dest !== undefined && (obj.dest = message.dest);
    if (message.meta) {
      obj.meta = message.meta.map((e) => (e ? Meta.toJSON(e) : undefined));
    } else {
      obj.meta = [];
    }
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<Header>, I>>(object: I): Header {
    const message = createBaseHeader();
    message.command = object.command ?? "";
    message.channelId = object.channelId ?? "";
    message.sequence = object.sequence ?? 0;
    message.flag = object.flag ?? 0;
    message.status = object.status ?? 0;
    message.dest = object.dest ?? "";
    message.meta = object.meta?.map((e) => Meta.fromPartial(e)) || [];
    return message;
  },
};

function createBaseInnerHandshakeReq(): InnerHandshakeReq {
  return { ServiceId: "" };
}

export const InnerHandshakeReq = {
  encode(
    message: InnerHandshakeReq,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.ServiceId !== "") {
      writer.uint32(10).string(message.ServiceId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): InnerHandshakeReq {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInnerHandshakeReq();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.ServiceId = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): InnerHandshakeReq {
    return {
      ServiceId: isSet(object.ServiceId) ? String(object.ServiceId) : "",
    };
  },

  toJSON(message: InnerHandshakeReq): unknown {
    const obj: any = {};
    message.ServiceId !== undefined && (obj.ServiceId = message.ServiceId);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<InnerHandshakeReq>, I>>(
    object: I
  ): InnerHandshakeReq {
    const message = createBaseInnerHandshakeReq();
    message.ServiceId = object.ServiceId ?? "";
    return message;
  },
};

function createBaseInnerHandshakeResponse(): InnerHandshakeResponse {
  return { Code: 0, Error: "" };
}

export const InnerHandshakeResponse = {
  encode(
    message: InnerHandshakeResponse,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.Code !== 0) {
      writer.uint32(8).uint32(message.Code);
    }
    if (message.Error !== "") {
      writer.uint32(18).string(message.Error);
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): InnerHandshakeResponse {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInnerHandshakeResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.Code = reader.uint32();
          break;
        case 2:
          message.Error = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): InnerHandshakeResponse {
    return {
      Code: isSet(object.Code) ? Number(object.Code) : 0,
      Error: isSet(object.Error) ? String(object.Error) : "",
    };
  },

  toJSON(message: InnerHandshakeResponse): unknown {
    const obj: any = {};
    message.Code !== undefined && (obj.Code = Math.round(message.Code));
    message.Error !== undefined && (obj.Error = message.Error);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<InnerHandshakeResponse>, I>>(
    object: I
  ): InnerHandshakeResponse {
    const message = createBaseInnerHandshakeResponse();
    message.Code = object.Code ?? 0;
    message.Error = object.Error ?? "";
    return message;
  },
};

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined;

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Long
  ? string | number | Long
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & {
      [K in Exclude<keyof I, KeysOfUnion<P>>]: never;
    };

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
